import axios from "axios";
import { EventBus } from "@/flit2go-web-core/util/event-bus.js";
import Vue from "vue";

// Start axios config
const $axios = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});
// Response errors detect
$axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const vueInstance = Vue.prototype.$instance;
    // D2: sin `response` no hay `status`. Se calcula UNA vez y con guarda, en vez de leerlo
    // dentro de una condición que ya asumió que no existe.
    const status = error.response ? error.response.status : null;
    // D1: `$instance` es un global que asigna el HOST, y frameweb no lo asigna. Sin router no
    // hay a dónde redirigir: se propaga el error ORIGINAL, que es lo que el llamante necesita
    // ver. Antes se lanzaba un TypeError que lo sustituía.
    const router = vueInstance && vueInstance._router;
    const rutaActual =
      router && router.apps[0] && router.apps[0]._route
        ? router.apps[0]._route.path
        : null;
    // Per-request opt-out: the caller handles the error itself
    const skipRedirect = !!(error.config && error.config.skipErrorRedirect);

    if (
      router &&
      !skipRedirect &&
      ((!error.response && rutaActual !== "/s/error") ||
        status === 502 ||
        status === 404)
    ) {
      vueInstance.$store.commit("auth/SET_LAST_ROUTE_VISITED", rutaActual);
      router.push("/s/error");
    } else if (
      status === 401 &&
      error.response.data &&
      error.response.data.error === "invalid_token"
    ) {
      EventBus.$emit("invalid_token", true);
    }
    return Promise.reject(error);
  }
);

export default {
  $axios: $axios,
  setToken(token) {
    $axios.defaults.headers.common["Authorization"] = "Bearer " + token;
  },
};
